import { z } from 'zod';
import { FieldSchema } from '../common';
import { InitialUIElement } from '../initial-ui-element';

export const NATIONALITY_PICKER_FIELD_ELEMENT_TYPE = 'nationalitypickerfield' as const;
export const NationalityPickerFieldElementType = z.literal(NATIONALITY_PICKER_FIELD_ELEMENT_TYPE);

export const NationalityPickerFieldParamsSchema = FieldSchema.extend({
  optionNotFoundText: z.string().optional(),
});

export type TNationalityPickerFieldParams = z.infer<typeof NationalityPickerFieldParamsSchema>;

export const NationalityPickerFieldElementSchema = InitialUIElement.extend({
  element: NationalityPickerFieldElementType,
  params: NationalityPickerFieldParamsSchema,
  valueDestination: z.string(),
});
